import {
    setDate,
    getDate,
    isSunday,
    addDays,
    subDays,
    startOfDay,
    startOfWeek,
    startOfMonth,
    endOfMonth,
    subMonths,
    endOfWeek,
    subWeeks,
    startOfYear,
    endOfYear,
    subYears,
    format,
    parse,
    endOfDay
} from 'date-fns';
import {
    IListItem,
    IPeriod,
    IPeriodStr,
    PeriodLength,
    IPeriodShort
} from '@/entities';
import { formatDate, nowEDT } from './date.utils';
const DATE_FORMAT = 'YYYY-MM-DD';

export function getDefaultDateRange() {
    const now = nowEDT();
    const start = startOfWeek(now);
    const end = endOfWeek(now);

    return {
        start,
        end
    };

    // if (!isSunday(now)) {
    //     return {
    //         start,
    //         end
    //     };
    // } else {
    //     return {
    //         start: subWeeks(start, 1),
    //         end: subWeeks(end, 1)
    //     };
    // }
}

export function createPeriodListItems(
    weeksCount: number,
    beWeeksCount: number
): IListItem[] {
    const res = [];
    const now = nowEDT();
    res.push(createWeekItem(now, 'This week'));
    res.push(createWeekItem(subWeeks(now, 1), 'Last week'));
    const firstWeek = subWeeks(now, 2);
    for (let i = 0; i < weeksCount; i++) {
        res.push(createWeekItem(subWeeks(firstWeek, i)));
    }
    const firstBeWeek = createBeWeekPeriod(now);
    for (let i = 0; i < beWeeksCount; i++) {
        res.push(createBeWeekItem(subPeriod(firstBeWeek, i)));
    }
    return res;
}

export function createBigPeriodListItems(): IListItem[] {
    const res = [];
    const now = nowEDT();
    // days

    res.push(createDayItem(now, 'Today'));
    res.push(createDayItem(subDays(now, 1), 'Yesterday'));

    res.push(createWeekItem(now, 'This week'));
    res.push(createWeekItem(subWeeks(now, 1), 'Last week'));

    res.push(createMonthItem(now, 'This month'));
    res.push(createMonthItem(subMonths(now, 1), 'Last month'));

    res.push(createYearItem(now, 'This year'));
    res.push(createYearItem(subYears(now, 1), 'Last year'));

    for (let i = 2; i < 12; i++) {
        res.push(createWeekItem(subWeeks(now, i)));
    }
    // month
    for (let i = 2; i <= 12; i++) {
        res.push(createMonthItem(subMonths(now, i)));
    }

    return res;
}

export function createAvpPeriodListItems(): IListItem[] {
    const res = [];
    const now = nowEDT();

    res.push(createWeekItem(subWeeks(now, 1), 'Last week'));

    for (let i = 2; i < 53; i++) {
        res.push(createWeekItem(subWeeks(now, i)));
    }

    return res;
}

export function refactorToPeriodStartListItem(period: IPeriod): IListItem {
    return createWeekStartItem(period.start);
}

export function refactorToPeriodEndListItem(period: IPeriod): IListItem {
    return createWeekEndItem(period.end);
}

export function parsePeriodListItem(str: string): IPeriod {
    const splits = str.split(',');
    return {
        start: parse(splits[0]),
        end: parse(splits[1]),
        periodLength: splits[2] as PeriodLength
    };
}

export function formatPeriod(period: IPeriod): string {
    const start = formatDate(period.start);
    const end = formatDate(period.end);
    return `${start} - ${end}`;
}

export function toStrPeriod(period: IPeriodShort): IPeriodStr {
    return {
        start: formatDate(period.start),
        end: formatDate(period.end)
    };
}

export function fromStrPeriod(period: IPeriodStr): IPeriodShort {
    return {
        start: parse(period.start),
        end: parse(period.end)
    };
}

function createDayItem(day: Date, title: string = null): IListItem {
    const period = {
        start: startOfDay(day),
        end: endOfDay(day),
        periodLength: PeriodLength.day
    };
    return {
        value: periodToStr(period),
        heading: title || format(period.start, DATE_FORMAT)
    };
}

function createWeekItem(weekDay: Date, title: string = null): IListItem {
    const period = {
        start: startOfWeek(weekDay),
        end: endOfWeek(weekDay),
        periodLength: PeriodLength.week
    };
    return {
        value: periodToStr(period),
        heading:
            title ||
            '[W] ' +
                format(period.start, DATE_FORMAT) +
                ' to ' +
                format(period.end, DATE_FORMAT)
    };
}

function createWeekStartItem(weekDay: Date, title: string = null): IListItem {
    const period = {
        start: startOfWeek(weekDay),
        end: endOfWeek(weekDay),
        periodLength: PeriodLength.week
    };
    return {
        value: periodToStr(period),
        heading:
            title ||
                format(period.start, DATE_FORMAT)
    };
}

function createWeekEndItem(weekDay: Date, title: string = null): IListItem {
    const period = {
        start: startOfWeek(weekDay),
        end: endOfWeek(weekDay),
        periodLength: PeriodLength.week
    };
    return {
        value: periodToStr(period),
        heading:
            title ||
                format(period.end, DATE_FORMAT)
    };
}

function createBeWeekItem(weekPeriod: IPeriod): IListItem {
    return {
        value: periodToStr(weekPeriod),
        heading:
            '[2W] ' +
            format(weekPeriod.start, DATE_FORMAT) +
            ' to ' +
            format(weekPeriod.end, DATE_FORMAT)
    };
}

function createMonthItem(monthDay: Date, title: string = null): IListItem {
    const period = {
        start: startOfMonth(monthDay),
        end: endOfMonth(monthDay),
        periodLength: PeriodLength.month
    };
    return {
        value: periodToStr(period),
        heading: title || 'Month ' + format(period.start, 'YYYY-MM')
    };
}

function createYearItem(yearDay: Date, title: string = null): IListItem {
    const period = {
        start: startOfYear(yearDay),
        end: endOfYear(yearDay),
        periodLength: PeriodLength.year
    };
    return {
        value: periodToStr(period),
        heading: title || 'Year ' + format(period.start, 'YYYY')
    };
}

function periodToStr(period: IPeriod): string {
    return (
        format(period.start, DATE_FORMAT) +
        ',' +
        format(period.end, DATE_FORMAT) +
        ',' +
        period.periodLength
    );
}

function createBeWeekPeriod(date: Date): IPeriod {
    if (getDate(date) <= 15) {
        return {
            start: startOfMonth(date),
            end: setDate(date, 15),
            periodLength: PeriodLength.beWeek
        };
    } else {
        return {
            start: setDate(date, 16),
            end: endOfMonth(date),
            periodLength: PeriodLength.beWeek
        };
    }
}

export function subPeriod(period: IPeriod, count: number): IPeriod {
    switch (period.periodLength) {
        case PeriodLength.day:
            return {
                start: subDays(period.start, 1),
                end: subDays(period.end, 1),
                periodLength: period.periodLength
            };
        case PeriodLength.week:
            return {
                start: subWeeks(period.start, 1),
                end: subWeeks(period.end, 1),
                periodLength: period.periodLength
            };
        case PeriodLength.beWeek:
            return subBeWeekPeriod(period, count);
        case PeriodLength.month:
            return {
                start: subMonths(period.start, 1),
                end: subMonths(period.end, 1),
                periodLength: period.periodLength
            };
        case PeriodLength.year:
            return {
                start: subYears(period.start, 1),
                end: subYears(period.end, 1),
                periodLength: period.periodLength
            };
    }
}

function subBeWeekPeriod(beWeek: IPeriod, count: number): IPeriod {
    if (beWeek.periodLength !== PeriodLength.beWeek) {
        throw new Error('Only for beWeek periods');
    }
    if (count === 0) {
        return beWeek;
    }
    const startDay = beWeek.start;
    let firstDay = subDays(
        subMonths(startDay, Math.floor(count / 2)),
        count % 2
    ); // always return 15day of this or early monthes
    return createBeWeekPeriod(firstDay);
}

export function comparePeriods(a: IPeriodShort, b: IPeriodShort) {
    if (!a || !b) {
        return false;
    }
    return (
        a.start.getTime() === b.start.getTime() &&
        a.end.getTime() === b.end.getTime()
    );
}
